import * as React from "react";
import { ContextMenu, ContextMenuItem } from "rctx-contextmenu";
import { ThunkDispatch } from "redux-thunk";
import { compose } from 'redux';
import { connect } from 'react-redux';
import { ColumnType } from "./PhasePlan/Column";
import { LookaheadTag } from '../models/LookaheadTag';
import PropTypes from 'prop-types';

import { getCopiedPhaseTags, getCopiedLookaheadTags } from "../selectors/dialog.selector";
import { lookaheadActions } from "../actions/lookahead.actions";
import { getLocalRowGroupStarts } from "../selectors/lookahead.selector";

const _ = require("lodash");

export const ROW_MENU_TYPE = 'row_context_menu';


interface Props {
    type: ColumnType;
    pasteTags: (isBacklog: boolean, type: ColumnType, isMilestone?: boolean, milestoneTags?: Record<string, LookaheadTag> ) => Promise<void>;
    columnSelectedAsync: (column: number, row:number, type:ColumnType) => void;
    tags: Record<string, LookaheadTag>;
    milestoneTags: Record<string, LookaheadTag>;
    pathName: string,
    groupRows: (initialRow: number) => void;
    rowGroupStarts: number[];
    trigger: any;
    id: string
}


const RowContextMenu: React.FC<Props> = (props) => {

    const { groupRows, rowGroupStarts, trigger, id } = props

    const handleColumnContextMenuClick = (e:any, data:any, target:any) => {
        const row = parseInt(target.getAttribute('row')) as number

        switch(data.action) {
            case 'Group':
                groupRows(row)
                break;                
        }
    }

    return(
        <React.Fragment>
            <ContextMenu id={ROW_MENU_TYPE}>
                <ContextMenuItem data={{ action: 'Group' }} onClick={handleColumnContextMenuClick}>
                    Group
                </ContextMenuItem>
            </ContextMenu>
        </React.Fragment>
    )
}

RowContextMenu.propTypes = {
    id: PropTypes.string.isRequired,
    trigger: PropTypes.shape({
        row: PropTypes.string.isRequired,
    }).isRequired
};

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
    return {
        groupRows: (initialRow: number) =>
         dispatch(lookaheadActions.groupRows(initialRow)),
        
    }
}

const mapStateToProps = (state:any) => ({
    copiedPhaseTags: getCopiedPhaseTags(state),
    copiedLookaheadTags: getCopiedLookaheadTags(state),
    rowGroupStarts:  getLocalRowGroupStarts(state)
    
})

export default compose<React.ComponentClass>(
    connect(mapStateToProps, mapDispatchToProps)
)(RowContextMenu)




// WEBPACK FOOTER //
// ./src/components/RowContextMenu.tsx